import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import BankSimulator from "./pages/BankSimulator";
import ViabilitySimulator from "./pages/ViabilitySimulator";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App min-h-screen bg-black">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/simulador-fintech" element={<BankSimulator />} />
          <Route path="/simulador-banco" element={<BankSimulator />} />
          <Route path="/simulador-viabilidade" element={<ViabilitySimulator />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
